export enum DIRECTORY_ENTRY {
    /**
     * @value Entry settings
     */
    CREATION_DIALOG_TITLE = 'ADMIN_DIRECTORY_ENTRY_SETTINGS',
    /**
     * @value Delete entries?
     */
    DELETE_ENTRIES = 'DIRECTORY_ENTRY.DELETE_ENTRIES',
    /**
     * @value Deleting entries is irreversible. You will delete their entire configuration.
     */
    DELETE_ENTRIES_DESCRIPTION = 'DIRECTORY_ENTRIES.DELETE_ENTRIES_DESCRIPTION',
    /**
     * @value Delete entry?
     */
    DELETE_ENTRY = 'DIRECTORY_ENTRIES.DELETE_ENTRY',
    /**
     * @value Deleting the entry %NAME% is irreversible. You will delete the entire configuration.
     */
    DELETE_ENTRY_DESCRIPTION = 'DIRECTORY_ENTRIES.DELETE_ENTRY_DESCRIPTION',
    /**
     * @value Edit entry
     */
    EDIT_ENTRY = 'DIRECTORY_ENTRIES.EDIT_ENTRY',
    /**
     * @value This page gives you access to all entries created
     */
    EMPTY_STATE_DESCRIPTION = 'DIRECTORY_ENTRIES.EMPTY_STATE_DESCRIPTION',
    /**
     * @value Entries deleted
     * @description Text to be displays as a successful notification when multiple entries is deleted from the system
     */
    ENTRIES_DELETED = 'DIRECTORY_ENTRIES.ENTRIES_DELETED',
    /**
     * @value Entry deleted
     * @description Text to be displays as a successful notification when an entry is deleted from the system
     */
    ENTRY_DELETED = 'DIRECTORY_ENTRIES.ENTRY_DELETED',
    /**
     * @value Entry name
     */
    ENTRY_NAME = 'ADMIN_DIRECTORY_ENTRY_NAME',
    /**
     * @value Add %NAME% entry to favorites
     * @description Text for screen readers on button focus.
     */
    FAVORITE_BUTTON_ARIA = 'FRONT.DIRECTORY_ENTRIES.FAVORITE_BUTTON.ARIA',
    /**
     * @value Force this entry in favorites for
     */
    IN_FAVORITE_FEEDS = 'ADMIN_DIRECTORY_ENTRY_IN_FAVORITE_FEEDS',
    /**
     * @value Deletable from favorites
     */
    IS_DELETABLE_FROM_FAVORITE = 'ADMIN.INSTANCE.IS_DELETABLE_FROM_FAVORITE',
    /**
     * @value New entry
     */
    NEW_ENTRY = 'DIRECTORY_ENTRIES.NEW_ENTRY',
    /**
     * @value No entries yet
     */
    NO_ENTRIES_YET = 'DIRECTORY_ENTRIES.NO_ENTRIES_YET',
    /**
     * @value Select a directory entry
     */
    PICKER_TITLE = 'DIRECTORY_ENTRIES.PICKER_TITLE',
    /**
     * @value Remove %NAME% entry from favorites
     * @description Tooltip displayed for the remove directory entry from favorite button
     */
    REMOVE_ENTRY_FROM_FAVORITE = 'DIRECTORY.REMOVE_ENTRY_FROM_FAVORITE',
}
